import React from 'react';
import { ProductFilterInput } from '../../../../generated/product-service-graphql';

const PendingFilters = ({
  filters,
  onRemove,
  onRemoveAll,
  findFilterLabelByValue,
}: {
  filters: ProductFilterInput[];
  onRemove: (filter: ProductFilterInput) => void;
  onRemoveAll: () => void;
  findFilterLabelByValue: (value: string) => string;
}) => {
  const handleRemove = (filter: ProductFilterInput, removeValue: string) => {
    onRemove({ key: filter.key, values: filter.values.filter((v) => v !== removeValue) });
  };

  return filters.length > 0 ? (
    <ul className="selected-filters d-flex">
      {filters.map((filter) => {
        return filter.values.map((value) => {
          return (
            <li className="selected-filter" key={`${filter.key}${value}`} onClick={() => handleRemove(filter, value)}>
              <span>{findFilterLabelByValue(value)}</span>
              <span className="alo-cross-primary-icon" style={{ width: '10px', height: '10px' }}></span>
            </li>
          );
        });
      })}
      {filters.length > 0 && (
        <li
          className="clear-all-selected-filters selected-filter"
          key="clear-all-selected-filters"
          onClick={onRemoveAll}
        >
          Clear All
        </li>
      )}
    </ul>
  ) : null;
};

export default PendingFilters;
